import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createOpportunityType,
  getAllOpportunityType,
  getOpportunityTypeById,
  updateOpportunityType,
} from "./services/opportunityType.services";
import { clearOpportunityTypeDetails } from "./opportunityTypeSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";

const CreateOpportunityType: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const OpportunityTypeDetail = useAppSelector(
    (state) => state.opportunityType.OpportunityTypeDetail
  );
  const OpportunityTypeGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector(
    (state) => state.opportunityType.formLoading
  );

  useEffect(() => {
    return () => {
      dispatch(clearOpportunityTypeDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (OpportunityTypeGUID) {
      dispatch(getOpportunityTypeById(OpportunityTypeGUID));
    }
  }, [OpportunityTypeGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!OpportunityTypeGUID) {
        const insertPayload = {
          OpportunityType: values?.OpportunityType
            ? values?.OpportunityType
            : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(createOpportunityType(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearOpportunityTypeDetails());
          dispatch(getAllOpportunityType());
        }
      } else {
        const editPayload = {
          OpportunityTypeGUID: OpportunityTypeGUID,
          OpportunityType: values?.OpportunityType
            ? values?.OpportunityType
            : "",
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(updateOpportunityType(editPayload));
        if (response?.payload?.Status === 200) {
          dispatch(closed());
          dispatch(clearOpportunityTypeDetails());
          dispatch(getAllOpportunityType());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={OpportunityTypeDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {OpportunityTypeGUID
                  ? "Update Opportunity Type"
                  : "Create Opportunity Type"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="OpportunityType"
                label="Opportunity Type"
                placeholder="Opportunity Type"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                label={"Status"}
                placeholder="Status"
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={OpportunityTypeGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateOpportunityType;
